import { LogOut, Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { LanguageToggle } from './LanguageToggle';
import type { Profile } from '@/types/app';

interface TopBarProps {
  profile: Profile;
  onToggleMenu: () => void;
  onSignOut: () => void;
}

export function TopBar({ profile, onToggleMenu, onSignOut }: TopBarProps) {
  const { t } = useTranslation();

  return (
    <header className="flex h-14 items-center gap-2 border-b border-slate-200 bg-white px-3">
      <button
        type="button"
        onClick={onToggleMenu}
        aria-label={t('nav.openMenu')}
        className="rounded-lg p-2 text-slate-600 hover:bg-slate-100 md:hidden"
      >
        <Menu className="size-5" aria-hidden="true" />
      </button>

      <span className="truncate text-sm font-semibold text-slate-900">{t('app.name')}</span>

      <div className="flex-1" />

      <span className="hidden text-xs text-slate-500 sm:inline">
        {profile.full_name} · {t(`roles.${profile.role}` as 'roles.sales')}
      </span>

      <LanguageToggle />

      <button
        type="button"
        onClick={onSignOut}
        aria-label={t('auth.signOut')}
        className="rounded-lg p-2 text-slate-600 hover:bg-slate-100"
      >
        <LogOut className="size-4" aria-hidden="true" />
      </button>
    </header>
  );
}
